import { Edit, Trash2, Users } from "lucide-react";

import { PoolModelData } from "../model/approvalPoolModel";
import Toast from "../../../../../components/Toast";

interface PoolCardProps {
  pool: PoolModelData;
  onEdit: (pool: PoolModelData) => void;
  onDelete: (id: string) => void;
  onDetails: (pool: PoolModelData) => void;
}

export const PoolCard = ({
  pool,
  onEdit,
  onDelete,
  onDetails,
}: PoolCardProps) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border p-4 hover:shadow-md transition-shadow">
      <div className="flex items-center space-x-3 mb-3">
        <div className="w-10 h-10 bg-indigo-100 rounded-full flex items-center justify-center">
          <span className="text-indigo-600 font-medium text-sm">
            {pool.name?.[0].toUpperCase()}
            {/* {candidate.last_name?.[0]} } */}
          </span>
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-medium text-gray-900 truncate">
            {pool.name}
          </h3>
          <p className="text-xs text-gray-500 truncate">
            {pool.member_count ?? 0} member(s)
          </p>
        </div>
        <button
          onClick={() => onEdit(pool)}
          className="border rounded p-1.5 hover:bg-gray-100"
        >
          <Edit className="h-3.5 w-3.5" />
        </button>

        <button
          onClick={() => onDelete(pool.id)}
          className="border rounded p-1.5 hover:bg-gray-100"
        >
          <Trash2 className="h-3.5 w-3.5 text-red-600" />
        </button>
      </div>

      <div className="flex items-start justify-between mt-4 gap-3">
        <div className="flex-1 min-w-0">
          {pool.description && (
            <p className="text-xs text-gray-600 line-clamp-2">
              {pool.description}
            </p>
          )}
        </div>

        <button
          onClick={() => onDetails(pool)}
          className="text-xs bg-indigo-600 text-white px-3 py-1 rounded hover:bg-indigo-700 shrink-0"
        >
          View
        </button>
      </div>
    </div>
  );
};
